import type { SVGProps } from 'react';
const resArrowRightTemplateOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.3295 12.7045C8.89017 13.1438 8.89017 13.8562 9.3295 14.2955C9.76884 14.7348 10.4812 14.7348 10.9205 14.2955L15.2216 9.99437C15.2572 9.95883 15.2904 9.92187 15.3213 9.88366C15.5824 9.67764 15.75 9.35839 15.75 9C15.75 8.64161 15.5824 8.32236 15.3213 8.11634C15.2904 8.07813 15.2572 8.04117 15.2216 8.00563L10.9205 3.7045C10.4812 3.26517 9.76884 3.26517 9.3295 3.7045L9.26379 3.77606C8.89138 4.21807 8.91329 4.87928 9.3295 5.2955L11.9092 7.875H3.375C2.75368 7.875 2.25 8.37868 2.25 9C2.25 9.62132 2.75368 10.125 3.375 10.125H11.9092L9.3295 12.7045Z"
      fill={props.color ?? '#144761'}
    />
  </svg>
);
export default resArrowRightTemplateOutline;
